import { NULL_STR } from '#/config/consts';

export const NULL_FILTER = NULL_STR;

export const NOT_ASSIGNED_LABEL = 'Unknown';
